import { PathPolyline } from 'entities/device.map.track/ui/leaflet-path';
import { createElementObject, createPathComponent, } from '@react-leaflet/core';
function createCustomPath(props, context) {
    const path = new PathPolyline([], undefined, props.device_id);
    path.setPoints(props.points, props.events, props.highlightTime);
    path.on('mouseover', props.onMouseOver);
    path.on('mouseout', props.onMouseOut);
    path.on('mousemove', (ev) => props.onMouseMove(path.find_points_near(ev.layerPoint), ev.containerPoint));
    return createElementObject(path, context);
}
function updateCustomPath(instance, props, prevProps) {
    if (prevProps.points.length !== props.points.length ||
        prevProps.highlightTime !== props.highlightTime ||
        prevProps.events.length !== props.events.length) {
        instance.setPoints(props.points, props.events, props.highlightTime);
    }
}
export const CustomPath = createPathComponent(createCustomPath, updateCustomPath);
